import React from 'react';
import NextNProgressBar from 'nextjs-progressbar';
import { colors } from '@stockx/ui';

// stockx green
const PageLoadingIndicator = () => (
  <NextNProgressBar
    color={colors.green['700']}
    options={{ showSpinner: false }}
  />
);

export default PageLoadingIndicator;
